import { Button, ButtonSize, Intent, Shape } from '@axieinfinity/matcha'
import { CopySimpleIcon } from '@axieinfinity/matcha-icons'

import { Box } from '~/components/Box'
import { Input } from '~/components/Input'
import { useWrappedToast } from '~/hooks/useWrappedToast'

import { useAccountInfo } from './useAccountInfo'

export const AccountInfo: React.FC = () => {
  const { user, errors, isLoading, onSubmitChangeName, onChangeForm } =
    useAccountInfo()
  const { showInfoMessage } = useWrappedToast()

  const onCopyUserId = () => {
    if (user?.userID) {
      navigator.clipboard.writeText(user?.userID)
      showInfoMessage('ID copied to clipboard')
    }
  }

  return (
    <form onSubmit={onSubmitChangeName}>
      <Box>
        <div className="p-24 flex flex-col gap-24">
          <div className="text-h6">Account Information</div>
          <div className="matcha-divider-bottom h-[1px]" />

          <div className="flex flex-col md:flex-row gap-40">
            <div className="flex flex-col w-full md:w-1/2">
              <div className="text-body-m-strong mb-4">User ID</div>
              <div className="text-body-s text-text-color-subdued">
                A unique identifier assigned to your account. This ID allows you
                to access and connect your profile across all games.
              </div>
            </div>
            <div className="flex-1 cursor-pointer">
              <Input
                className="[&>div>input]:text-ellipsis"
                shape={Shape.Default}
                suffixIcon={<CopySimpleIcon onClick={onCopyUserId} />}
                readOnly
                value={user?.userID}
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row gap-40">
            <div className="flex flex-col w-full md:w-1/2">
              <div className="text-body-m-strong mb-4">Display Name</div>
              <div className="text-body-s text-text-color-subdued">
                Sky Mavis players can locate you through the social panel in our
                games using your display name.
              </div>
            </div>
            <div className="flex-1 cursor-pointer">
              <Input
                shape={Shape.Default}
                maxLength={255}
                intent={Intent.Default}
                defaultValue={user?.name}
                error={errors.name}
                name="name"
                onChange={onChangeForm}
              />
            </div>
          </div>
        </div>

        <div className="matcha-divider-bottom h-[1px]" />

        <div className="flex justify-end py-[14px] px-24">
          <Button
            loading={isLoading}
            text="Save"
            size={ButtonSize.Small}
            type="submit"
            shape={Shape.Default}
          />
        </div>
      </Box>
    </form>
  )
}
